<template>
	<feature-item-skeleton divided class="mb-16">

		<template #info>
			<div class="flex flex-column items-end">
				<skeleton height="22" width="80" class="mb-10" rounded/>
				<skeleton height="12" width="100" class="mb-1" rounded/>
			</div>
		</template>

		<template #actions>
			<div class="mt-16 flex justify-end">
				<skeleton height="40" :width="172.55" rounded/>
			</div>
		</template>

	</feature-item-skeleton>
</template>

<script>

export default {
        name: 'FinisherPointsProductCardSkeleton',
    }
</script>

